/* eslint-disable no-redeclare */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-console */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable no-loop-func */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import {
  map,
} from 'ramda';
import debounce from 'debounce';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

const styles = () => ({
  formRoot: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '100%',
    paddingBottom: '2em',
  },
});

const useStyles = () => ({
  input: {
    display: 'none',
  },
});

var selectedTeams = [];

const SEARCH_TEAMS = gql`
query searchTeams($filter: String!, $skip: Int!, $limit: Int!) {
  searchTeams(filter: $filter, skip: $skip, limit: $limit) {
    team_id
    display_name
  }
}
`;

class CopyRoleHeader extends React.Component {
  updateSuggestions = debounce(async (searchString) => {
    const teams = await this.fetchTeams(searchString);
    const suggestions = map(
      ({ team_id: id, display_name: displayName }) => ({
        id,
        description: `${displayName} (${id})`,
      }),
      teams,
    );
    this.setState({ suggestions });
    this.setUpBoxes(suggestions);
  }, 300);

  constructor(props) {
    super(props);

    this.state = {
      team: '',
      suggestions: [],
      searchError: null,
    };
  }

  componentDidMount = () => {
    this.updateSuggestions('');
  }

  setUpBoxes = (suggestions) => {
    if (suggestions) {
      var boxes = [];
      for (var x in suggestions) {
        boxes.push(
          <TableRow>
            <TableCell padding="none">
              <Checkbox
                value={String(suggestions[x].id)}
                id={String(suggestions[x].id)}
                inputProps={{ 'aria-label': 'uncontrolled-checkbox' }}
                onChange={(event) => {
                  if (event.target.checked && selectedTeams.includes(event.target) === false) {
                    selectedTeams.push(event.target);
                  } else if (event.target.checked === false && selectedTeams.includes(event.target.value)) {
                    selectedTeams = selectedTeams.filter(team => team !== event.target);
                  }
                }}
              />
              <TableSortLabel>
                {String(suggestions[x].description)}
              </TableSortLabel>
            </TableCell>
          </TableRow>,
        );
      }
      var classes = useStyles();
      boxes.push(
        <div>
          <Button
            className={classes.button}
            onClick={() => {
              for (var i in suggestions) {
                var target = document.getElementById(String(suggestions[i].id));
                if (target.checked === false) {
                  target.click();
                }
              }
            }
            }
          >
            Select All
          </Button>
        </div>,
      );
      return boxes;
    }
  }

  fetchTeams = async (searchString) => {
    const { client } = this.props;

    try {
      const { data: { searchTeams: teams } } = await client.query({
        query: SEARCH_TEAMS,
        variables: {
          filter: searchString,
          skip: 0,
          limit: 20,
        },
      });
      return teams;
    } catch (error) {
      this.setState({
        searchError: new Error('Unable to load team suggestions'),
      });
    }
  }

  render() {
    const { classes } = this.props;
    const {
      suggestions, searchError,
    } = this.state;

    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Team</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.setUpBoxes(suggestions)}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

CopyRoleHeader.propTypes = {
  name: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};


CopyRoleHeader.selectedTeams = selectedTeams;
export default withStyles(styles)(withApollo(CopyRoleHeader));
